// extracted by mini-css-extract-plugin
module.exports = {"root":"z_M","nav":"z_bK","carousel":"z_bL","slide":"z_bM"};